import { HOME_SCREEN_QUESTION, QUIZ_TYPE as quizType } from "./constants";

const QUIZ_TYPE = `${quizType}UserSessionData`;

const QuizFirstQuestion = (answer) => {
  const firstQuestion = {
    quizz_type: quizType,
    content: {
      to_pass: {
        current_question: HOME_SCREEN_QUESTION,
        qa_hist: [],
        answer_history: [],
        secondary_filter_cache: {},
      },
      to_update: {
        current_answers: [answer],
        edit_flag: 0,
        edit_index: 0,
      },
      to_use: {
        qa_hist: [],
        next_question: "",
        next_choices: [],
        skippable: 0,
        multichoice: 0,
        gray_map: [],
        skus: [],
      },
    },
  };

  return firstQuestion;
};

const StoreDataInLocalStorage = (key, value, isArray = false) => {
  let localObjectData = getQuizData();

  if (localObjectData) {
    if (isArray) {
      let keyData = localObjectData[key] || [];
      keyData.push(value);

      // updated the array into the particular key into the quiz data of local storage
      localObjectData[key] = keyData;
      localStorage.setItem(QUIZ_TYPE, JSON.stringify(localObjectData));
    } else {
      localObjectData[key] = value;
      localStorage.setItem(QUIZ_TYPE, JSON.stringify(localObjectData));
    }
  }
};

const GetDataFromLocalStorage = (key) => {
  let localObjectData = getQuizData();
  let data;

  if (localObjectData) {
    data = localObjectData[key] || null;
  } else {
    data = null;
  }

  return data;
};

const RemoveLastValueFromLocalStorage = (key) => {
  // get the particular quiz's data from the local storage.
  let localObjectData = getQuizData();

  if (localObjectData) {
    // extract particular key's data from the selected quiz.
    let keyData = localObjectData[key];

    // removed the last entry from particular key.
    keyData.pop();

    // updated the particular key's data into quiz local storage and then,
    // update the particular quiz's object into the local storage.
    localObjectData[key] = keyData;
    localStorage.setItem(QUIZ_TYPE, JSON.stringify(localObjectData));
  }
};

const RemoveKeyFromLocalStorage = (key) => {
  let localObjectData = getQuizData();

  if (localObjectData) {
    delete localObjectData[key];
    localStorage.setItem(QUIZ_TYPE, JSON.stringify(localObjectData));
  }
};

const ClearLocalStorage = () => {
  // clear all the key values from the particular quiz local storage data.
  localStorage.setItem(QUIZ_TYPE, JSON.stringify({}));
};

const getQuizData = () => {
  let localData = localStorage.getItem(QUIZ_TYPE);
  let localObjectData = JSON.parse(localData);
  if (!localObjectData) {
    localStorage.setItem(QUIZ_TYPE, JSON.stringify({}));
  }
  return localObjectData;
};

export {
  StoreDataInLocalStorage,
  GetDataFromLocalStorage,
  RemoveLastValueFromLocalStorage,
  RemoveKeyFromLocalStorage,
  ClearLocalStorage,
  QuizFirstQuestion,
};
